import type { CountryBiasLocale } from './types';

export const ru: CountryBiasLocale = {
  countries: [
    {
      id: 'ar',
      name: 'Аргентина',
      flag: '🇦🇷',
      region: 'Americas',
      rationale:
        'Коллективистская, высокое избегание неопределённости, эмоционально выразительная, краткосрочно-ориентированная',
      biases: [50, 53, 93, 79, 37, 22, 55, 91, 75, 100, 13],
      confidence: 0.74,
      aliases: ['Аргентинец', 'Аргентинский', 'Argentine', 'Argentinian'],
      biasRationale: `Аргентина имеет умеренно коллективистскую культуру (IDV 46) с высоким избеганием неопределённости (86) и очень высокой степенью допущения (62). Это создаёт культуру, где групповой консенсус и эмоциональное повествование определяют решения, тогда как избегание неопределённости подталкивает к знакомым опциям. Высокая степень допущения проявляется как восприимчивость к мгновенному вознаграждению и предубеждениям к позитивности.`,
    },
    {
      id: 'am',
      name: 'Армения',
      flag: '🇦🇲',
      region: 'Middle East',
      rationale:
        'Коллективистская, высокая дистанция власти, сохраняющая традиции, связанная с диаспорой, ориентированная на семью',
      biases: [48, 53, 50, 88, 81, 19, 47, 90, 70, 25, 52],
      confidence: 0.67,
      aliases: ['Армянин', 'Армянский', 'Айастан', 'Armenian', 'Hayastan'],
      biasRationale: `Армения демонстрирует высокую дистанцию власти и сильный коллективизм, укоренённый в древних культурных традициях и глубокой семейной структуре. Опыт диаспоры усиливает ингрупповой фаворитизм и эффекты владения вокруг культурного наследия. Высокое избегание неопределённости и долгосрочная ориентация, выработанные веками устойчивости, формируют консерватизм и эскалацию обязательств в принятии решений.`,
    },
    {
      id: 'au',
      name: 'Австралия',
      flag: '🇦🇺',
      region: 'Oceania',
      rationale:
        'Индивидуалистическая, антиавторитарная, толерантная к риску, прагматично-непринуждённая',
      biases: [91, 13, 44, 79, 80, 78, 55, 12, 74, 77, 71, 37],
      confidence: 0.87,
      aliases: ['Австралиец', 'Австралийский', 'Australian', 'Aussie'],
      biasRationale: `Австралия имеет очень высокий индивидуализм (90) и допущение (71) при заметно низкой дистанции власти (38). Антиавторитарная культура «синдрома высокого мака» подпитывает реактивность и фундаментальную ошибку атрибуции, а высокое допущение порождает гиперболическое дисконтирование и эффекты позитивности. Сильный индивидуализм формирует иллюзорное превосходство и сверхуверенность в собственных суждениях.`,
    },
    {
      id: 'at',
      name: 'Австрия',
      flag: '🇦🇹',
      region: 'Europe',
      rationale:
        'Умеренный индивидуализм, высокое избегание неопределённости, маскулинно-достиженческая, структурированная',
      biases: [86, 93, 69, 44, 19, 102, 85, 87, 81, 20, 94],
      confidence: 0.8,
      aliases: ['Австриец', 'Австрийский', 'Austrian'],
      biasRationale: `Австрия имеет высокий показатель маскулинности (79) и избегания неопределённости (70) при умеренном индивидуализме (55). Достиженческая культура в сочетании с потребностью в структуре формирует предубеждение к нулевому риску и избегание неоднозначности. Высокая маскулинность порождает сверхуверенность и фундаментальную ошибку атрибуции, а австрийская склонность к деталям создаёт опору на систематическую обработку и поиск информации.`,
    },
    {
      id: 'be',
      name: 'Бельгия',
      flag: '🇧🇪',
      region: 'Europe',
      rationale:
        'Высокое избегание неопределённости, умеренный индивидуализм, стремление к консенсусу, лингвистически разделённая',
      biases: [93, 86, 19, 50, 70, 94, 92, 10, 58, 102, 85],
      confidence: 0.79,
      aliases: ['Бельгиец', 'Бельгийский', 'Belgian'],
      biasRationale: `Бельгия имеет очень высокое избегание неопределённости (94) при умеренном индивидуализме (75) и низком допущении (57). Сильное избегание неопределённости формирует избегание неоднозначности и предубеждение к нулевому риску, а консенсусная культура между лингвистическими сообществами порождает эффект подражания и социальную желательность. Сдержанность вносит вклад в предубеждение к бездействию и нормальностное предубеждение.`,
    },
    {
      id: 'br',
      name: 'Бразилия',
      flag: '🇧🇷',
      region: 'Americas',
      rationale:
        'Высокая дистанция власти, коллективистская, потворствующая, эмоционально выразительная',
      biases: [79, 55, 50, 37, 13, 75, 100, 22, 41, 53, 48, 84],
      confidence: 0.82,
      aliases: ['Бразилец', 'Бразильский', 'Brazilian', 'Brasil'],
      biasRationale: `Бразилия имеет высокую дистанцию власти (69) и очень высокое допущение (59) при сильном коллективизме (IDV 38). Потворствующая, эмоционально выразительная культура формирует гиперболическое дисконтирование и эффекты позитивности, а коллективизм порождает эффект подражания и ингрупповые предубеждения. Высокая дистанция власти усиливает авторитарное предубеждение, а яркая традиция повествования делает анекдотические свидетельства особенно убедительными.`,
    },
    {
      id: 'ca',
      name: 'Канада',
      flag: '🇨🇦',
      region: 'Americas',
      rationale:
        'Индивидуалистическая, эгалитарная, мультикультурно-консенсусная, умеренное избегание неопределённости',
      biases: [70, 50, 77, 55, 91, 80, 22, 93, 97, 10, 13, 44],
      confidence: 0.87,
      aliases: ['Канадец', 'Канадский', 'Canadian'],
      biasRationale: `Канада имеет высокий индивидуализм (80) при низкой дистанции власти (39) и умеренном допущении (68). Мультикультурная консенсусная культура порождает социальную желательность и эффект подражания наряду с индивидуалистическим иллюзорным превосходством. Умеренное избегание неопределённости (48) в сочетании с нормами вежливости создаёт склонность к предубеждению к бездействию, а допущение порождает обращение к новизне и эффекты позитивности.`,
    },
    {
      id: 'cl',
      name: 'Чили',
      flag: '🇨🇱',
      region: 'Americas',
      rationale:
        'Умеренный коллективизм, высокое избегание неопределённости, классово-сознательная, сдержанная',
      biases: [93, 86, 48, 90, 19, 83, 10, 30, 50, 57, 81],
      confidence: 0.73,
      aliases: ['Чилиец', 'Чилийский', 'Chilean'],
      biasRationale: `Чили имеет высокое избегание неопределённости (86) при умеренном коллективизме (IDV 23) и заметно низком допущении (28). Высокое избегание неопределённости создаёт сильные предубеждения к неоднозначности и нулевому риску, а сдержанность порождает предубеждение к бездействию и эффекты страуса. Классово-сознательные социальные иерархии формируют авторитарное предубеждение и оправдание системы, а потерь-избегание усиливается осознанием экономической волатильности.`,
    },
    {
      id: 'cn',
      name: 'Китай',
      flag: '🇨🇳',
      region: 'Asia',
      rationale:
        'Коллективистская, высокая дистанция власти, долгосрочно-стратегическая, сохраняющая лицо',
      biases: [48, 81, 90, 22, 18, 57, 83, 50, 42, 104, 53, 70, 19],
      confidence: 0.88,
      aliases: ['Китаец', 'Китайский', 'Chinese', 'Zhongguo'],
      biasRationale: `Китай имеет очень высокую долгосрочную ориентацию (87) и дистанцию власти (80) при сильном коллективизме (IDV 20). Долгосрочно-стратегическая культура формирует эскалацию обязательств, потерь-избегание и ментальный учёт. Высокая дистанция власти порождает авторитарное предубеждение и оправдание системы, а сохраняющий лицо коллективизм создаёт социальную желательность, эффекты подражания и сильный ингрупповой фаворитизм.`,
    },
    {
      id: 'co',
      name: 'Колумбия',
      flag: '🇨🇴',
      region: 'Americas',
      rationale:
        'Коллективистская, высокая дистанция власти, потворствующая, ориентированная на семью, предпринимательская',
      biases: [48, 53, 79, 55, 37, 50, 13, 75, 22, 41, 100],
      confidence: 0.72,
      aliases: ['Колумбиец', 'Колумбийский', 'Colombian'],
      biasRationale: `Колумбия имеет высокую дистанцию власти (67) и очень высокое допущение (83) при сильном коллективизме (IDV 13). Высокопотворствующая культура формирует гиперболическое дисконтирование и эффекты позитивности, а коллективизм и семейная ориентация порождают ингрупповой фаворитизм и эффекты подражания. Предпринимательский дух в сочетании с традицией повествования создаёт восприимчивость к ошибке «горячей руки» и яркой нарративной убедительности.`,
    },
    {
      id: 'cz',
      name: 'Чехия',
      flag: '🇨🇿',
      region: 'Europe',
      rationale:
        'Индивидуалистическая, прагматичная, высокое избегание неопределённости, сдержанная, скептичная',
      biases: [93, 19, 91, 30, 10, 17, 86, 83, 87, 71, 25],
      confidence: 0.74,
      aliases: ['Чех', 'Чешский', 'Czech', 'Czechia'],
      biasRationale: `Чехия имеет высокий индивидуализм (58) с заметным избеганием неопределённости (74) и очень низким допущением (29). Сдержанная скептичная культура порождает предубеждения к страусу и бездействию наряду с предубеждением к негативности. Высокое избегание неопределённости формирует избегание неоднозначности и консерватизм, а прагматичный индивидуализм создаёт реактивность к внешнему давлению и вовлечённость через сложность обработки.`,
    },
    {
      id: 'dk',
      name: 'Дания',
      flag: '🇩🇰',
      region: 'Europe',
      rationale:
        'Высокий индивидуализм, эгалитарная, фемининная культура, низкая дистанция власти, потворствующая',
      biases: [70, 58, 97, 10, 50, 55, 80, 13, 85, 93, 44],
      confidence: 0.83,
      aliases: ['Датчанин', 'Датский', 'Danish', 'Dane'],
      biasRationale: `Дания имеет очень высокий индивидуализм (74) при крайне низкой дистанции власти (18) и высоком допущении (70). Эгалитарная культура «Янтелаген» формирует социальную желательность и нормальностное предубеждение, ограничивая самопрезентацию. Низкая маскулинность (16) порождает консенсус через эффект подражания, а допущение создаёт обращение к новизне и предубеждения к позитивности. Фемининная культура ценит простоту по принципу «меньше — лучше».`,
    },
    {
      id: 'eg',
      name: 'Египет',
      flag: '🇪🇬',
      region: 'Middle East',
      rationale:
        'Высокая дистанция власти, коллективистская, сдержанная, заякоренная в традициях, высокое избегание неопределённости',
      biases: [48, 53, 90, 19, 47, 93, 52, 70, 88, 58, 25, 30],
      confidence: 0.72,
      aliases: ['Египтянин', 'Египетский', 'Egyptian', 'Misr'],
      biasRationale: `Египет имеет очень высокую дистанцию власти (70) при сильном коллективизме и высокой сдержанности. Заякоренная в традициях культура с прочной авторитарной структурой формирует авторитарное предубеждение, оправдание системы и консерватизм. Высокое избегание неопределённости порождает избегание неоднозначности, а коллективизм создаёт ингрупповой фаворитизм и аутгрупповую гомогенность. Сдержанность проявляется как эффект страуса и социальная желательность.`,
    },
    {
      id: 'et',
      name: 'Эфиопия',
      flag: '🇪🇹',
      region: 'Africa',
      rationale:
        'Коллективистская, общинная, высокая дистанция власти, устная традиция, духовно-ориентированная',
      biases: [48, 53, 37, 47, 50, 31, 96, 76, 19, 70, 58],
      confidence: 0.66,
      aliases: ['Эфиоп', 'Эфиопский', 'Ethiopian'],
      biasRationale: `Эфиопия демонстрирует высокую дистанцию власти и сильный коллективизм, укоренённые в общинной социальной структуре и глубоких духовных традициях. Богатая устная традиция повествования делает анекдотические свидетельства и ошибку конъюнкции особенно влиятельными. Авторитарное предубеждение и ошибка справедливого мира усиливаются религиозными рамками, а общинное принятие решений порождает эффекты подражания и ингрупповой фаворитизм.`,
    },
    {
      id: 'fi',
      name: 'Финляндия',
      flag: '🇫🇮',
      region: 'Europe',
      rationale:
        'Индивидуалистическая, низкая дистанция власти, высокое избегание неопределённости, сдержанная, эгалитарная',
      biases: [93, 86, 10, 30, 70, 87, 102, 85, 17, 94, 58, 19],
      confidence: 0.83,
      aliases: ['Финн', 'Финский', 'Suomi', 'Finnish'],
      biasRationale: `Финляндия имеет высокий индивидуализм (63) при очень низкой дистанции власти (33), высоком избегании неопределённости (59) и заметно низком допущении (57). Сдержанная культура «sisu» формирует предубеждения к бездействию и эффекты страуса, а избегание неопределённости создаёт избегание неоднозначности и предубеждение к нулевому риску. Методичный финский подход порождает вовлечённость через сложность обработки и предпочтение последовательного запоминания, а социальная желательность отражает сдержанный стиль общения.`,
    },
    {
      id: 'fr',
      name: 'Франция',
      flag: '🇫🇷',
      region: 'Europe',
      rationale:
        'Индивидуалистическая, но иерархичная, движимая эстетикой, интеллектуально-противоречивая',
      biases: [54, 20, 91, 89, 92, 97, 104, 71, 14, 83, 69, 87],
      confidence: 0.88,
      aliases: ['Француз', 'Французский', 'French'],
      biasRationale: `Франция имеет высокий индивидуализм (71) при заметной дистанции власти (68) и высоком избегании неопределённости (86). Эстетико-ориентированная культура усиливает эффекты ореола и контраста, а интеллектуальная противоречивость подпитывает реактивность и эффекты обратной отдачи. Высокое избегание неопределённости в сочетании с индивидуализмом создаёт уникальный профиль, где сверхуверенность встречается с потерь-избеганием, а упор на интеллектуальную строгость формирует вовлечённость через сложность обработки.`,
    },
    {
      id: 'de',
      name: 'Германия',
      flag: '🇩🇪',
      region: 'Europe',
      rationale:
        'Ориентированная на правила, инженерное мышление, движимая точностью, умеренный индивидуализм',
      biases: [87, 94, 86, 19, 25, 49, 102, 85, 81, 93, 83, 17],
      confidence: 0.89,
      aliases: ['Немец', 'Немецкий', 'Германский', 'German', 'Deutsche'],
      biasRationale: `Германия имеет высокий индивидуализм (67) при сильном избегании неопределённости (65) и высокой долгосрочной ориентации (83). Инженерно-точностная культура формирует вовлечённость через сложность обработки, информационное предубеждение и предпочтение последовательного запоминания. Избегание неопределённости порождает предубеждения к нулевому риску и неоднозначности, а долгосрочная ориентация усиливает эскалацию обязательств и потерь-избегание. Ориентированный на правила менталитет создаёт консерватизм и предубеждение подтверждения.`,
    },
    {
      id: 'gr',
      name: 'Греция',
      flag: '🇬🇷',
      region: 'Europe',
      rationale:
        'Склонная к коллективизму, очень высокое избегание неопределённости, высокая дистанция власти, потворствующая',
      biases: [93, 86, 48, 53, 79, 55, 91, 88, 19, 37, 100, 81],
      confidence: 0.75,
      aliases: ['Грек', 'Греческий', 'Hellenic', 'Greek', 'Hellas'],
      biasRationale: `Греция имеет самое высокое избегание неопределённости в Европе (100) при высокой дистанции власти (60) и умеренном коллективизме (IDV 35). Экстремальное избегание неопределённости формирует предубеждения к неоднозначности и нулевому риску, а потворствующая средиземноморская культура (IVR 50) порождает гиперболическое дисконтирование и эффекты позитивности. Сильный семейный коллективизм создаёт ингрупповой фаворитизм, а риторическая традиция усиливает убедительность анекдотических свидетельств.`,
    },
    {
      id: 'in',
      name: 'Индия',
      flag: '🇮🇳',
      region: 'Asia',
      rationale:
        'Иерархическая, коллективистская, долгосрочно-ориентированная, культура торга',
      biases: [48, 53, 25, 81, 47, 96, 57, 18, 36, 42, 50, 88, 90],
      confidence: 0.85,
      aliases: ['Индиец', 'Индийский', 'Indian', 'Bharat'],
      biasRationale: `Индия имеет очень высокую дистанцию власти (77) при сильной долгосрочной ориентации (51) и умеренном коллективизме (IDV 48). Иерархическая культура формирует авторитарное предубеждение и оправдание системы, а традиция торга усиливает эффекты якорения и ментального учёта. Долгосрочная ориентация порождает эскалацию обязательств, а традиция повествования делает ошибку конъюнкции и анекдотические нарративы крайне убедительными.`,
    },
    {
      id: 'id',
      name: 'Индонезия',
      flag: '🇮🇩',
      region: 'Asia',
      rationale:
        'Коллективистская, высокая дистанция власти, ищущая гармонии, духовно-ориентированная',
      biases: [48, 50, 70, 58, 10, 30, 47, 90, 53, 31, 19, 42],
      confidence: 0.78,
      aliases: ['Индонезиец', 'Индонезийский', 'Indonesian'],
      biasRationale: `Индонезия имеет очень высокую дистанцию власти (78) при сильном коллективизме (IDV 14) и низком допущении (38). Ищущая гармонии культура «musyawarah» формирует социальную желательность, предубеждение к бездействию и нормальностное предубеждение. Высокая дистанция власти порождает авторитарное предубеждение и оправдание системы, а духовная основа усиливает ошибку справедливого мира и субъективное подтверждение. Сдержанность проявляется как избегание конфронтации через эффект страуса.`,
    },
    {
      id: 'ir',
      name: 'Иран',
      flag: '🇮🇷',
      region: 'Middle East',
      rationale:
        'Высокая дистанция власти, коллективистская, высокое избегание неопределённости, сдержанная, сохраняющая традиции',
      biases: [48, 90, 19, 93, 53, 52, 88, 47, 30, 10, 70, 89],
      confidence: 0.68,
      aliases: ['Иранец', 'Персидский', 'Персия', 'Iranian', 'Persian'],
      biasRationale: `Иран имеет очень высокую дистанцию власти и избегание неопределённости при сильном коллективизме и сдержанности. Сохраняющая традиции культура формирует консерватизм, оправдание системы и авторитарное предубеждение. Высокое избегание неопределённости порождает избегание неоднозначности, а коллективизм усиливает ингрупповой фаворитизм и аутгрупповую гомогенность. Сдержанность и культурная устойчивость создают предубеждения к страусу и бездействию, а эффекты обратной отдачи отражают сопротивление внешним нарративам.`,
    },
    {
      id: 'ie',
      name: 'Ирландия',
      flag: '🇮🇪',
      region: 'Europe',
      rationale:
        'Индивидуалистическая, низкая дистанция власти, маскулинная, краткосрочно-ориентированная, очень потворствующая',
      biases: [13, 37, 79, 55, 80, 91, 44, 77, 12, 100, 75],
      confidence: 0.76,
      aliases: ['Ирландец', 'Ирландский', 'Irish', 'Eire'],
      biasRationale: `Ирландия имеет высокий индивидуализм (70) при низкой дистанции власти (28) и очень высоком допущении (65). Культура повествования делает анекдотические свидетельства и эффекты юмора особенно мощными. Высокое допущение формирует гиперболическое дисконтирование и эффекты позитивности, а индивидуализм порождает иллюзорное превосходство и реактивность. Краткосрочная ориентация (LTO 24) создаёт обращение к новизне, а общительная культура усиливает эффекты странности и Барнума.`,
    },
    {
      id: 'il',
      name: 'Израиль',
      flag: '🇮🇱',
      region: 'Middle East',
      rationale:
        'Прямой стиль общения, культура стартапов, заботящаяся о безопасности, низкая дистанция власти',
      biases: [69, 91, 89, 74, 80, 83, 1, 36, 79, 84, 78, 77],
      confidence: 0.84,
      aliases: ['Израильтянин', 'Израильский', 'Israeli'],
      biasRationale: `Израиль имеет низкую дистанцию власти (13) при высоком индивидуализме (54) и умеренном избегании неопределённости (81). Стартап-культура «хуцпы» формирует сверхуверенность, эффект Даннинга-Крюгера и иллюзорное превосходство, а прямой стиль общения порождает реактивность и эффекты обратной отдачи. Озабоченность безопасностью усиливает эвристику доступности и пренебрежение вероятностями, а инновационная экономика создаёт обращение к новизне и эффект IKEA.`,
    },
    {
      id: 'it',
      name: 'Италия',
      flag: '🇮🇹',
      region: 'Europe',
      rationale:
        'Индивидуалистическая, высокое избегание неопределённости, маскулинная, движимая эстетикой, ориентированная на семью',
      biases: [54, 93, 86, 20, 53, 69, 14, 92, 104, 83, 88, 79],
      confidence: 0.84,
      aliases: ['Итальянец', 'Итальянский', 'Italian'],
      biasRationale: `Италия имеет высокий индивидуализм (76), маскулинность (70) и избегание неопределённости (75). Эстетически-одержимая культура усиливает эффекты ореола и превосходства изображения, а высокое избегание неопределённости создаёт предубеждения к неоднозначности и нулевому риску. Маскулинность формирует сверхуверенность и конкурентное обрамление через эффекты контраста и приманки. Семейный коллективизм на местном уровне порождает ингрупповой фаворитизм, а потерь-избегание и эффект владения усиливаются ценностями сохранения наследия.`,
    },
    {
      id: 'jp',
      name: 'Япония',
      flag: '🇯🇵',
      region: 'Asia',
      rationale:
        'Коллективистская, экстремально высокое избегание неопределённости, иерархическая, перфекционистская в деталях',
      biases: [50, 90, 19, 48, 70, 93, 86, 101, 54, 102, 81, 83, 10],
      confidence: 0.9,
      aliases: ['Японец', 'Японский', 'Japanese', 'Nippon'],
      biasRationale: `Япония имеет крайне высокое избегание неопределённости (92) и долгосрочную ориентацию (88) при сильной маскулинности (95) и коллективизме (IDV 46). Перфекционистская культура формирует предубеждение к нулевому риску, избегание неоднозначности и тщательную обработку через последовательное запоминание. Высокий коллективизм порождает эффекты подражания и социальную желательность, а долгосрочная ориентация усиливает эскалацию обязательств и потерь-избегание. Иерархическая структура создаёт авторитарное предубеждение и оправдание системы.`,
    },
    {
      id: 'ke',
      name: 'Кения',
      flag: '🇰🇪',
      region: 'Africa',
      rationale:
        'Общинная, мобильно-ориентированная экономика, изобретательная, традиция устного повествования',
      biases: [37, 53, 79, 41, 76, 40, 84, 96, 69, 55, 48, 50],
      confidence: 0.73,
      aliases: ['Кениец', 'Кенийский', 'Kenyan'],
      biasRationale: `Кения демонстрирует умеренный коллективизм с предпринимательским динамизмом и mobile-first цифровой экономикой. Традиция устного повествования делает анекдотические свидетельства и ошибку конъюнкции крайне убедительными. Общинное принятие решений порождает ингрупповой фаворитизм и эффекты подражания, а изобретательная предпринимательская культура формирует иллюзию контроля, сверхуверенность и эффект IKEA от самостоятельно созданных решений.`,
    },
    {
      id: 'my',
      name: 'Малайзия',
      flag: '🇲🇾',
      region: 'Asia',
      rationale:
        'Очень высокая дистанция власти, коллективистская, умеренное избегание неопределённости, ищущая гармонии',
      biases: [48, 50, 53, 90, 70, 58, 10, 47, 22, 88, 19],
      confidence: 0.75,
      aliases: ['Малазиец', 'Малайзийский', 'Malaysian'],
      biasRationale: `Малайзия имеет самую высокую дистанцию власти в мире (100) при сильном коллективизме (IDV 26) и умеренном избегании неопределённости (36). Экстремальная дистанция власти формирует авторитарное предубеждение и оправдание системы, а ищущий гармонии коллективизм порождает эффекты подражания, ингрупповой фаворитизм и социальную желательность. Культура «сохранения лица» усиливает предубеждение к бездействию и нормальностное предубеждение, а эффекты обрамления усиливаются мультиэтнической традицией консенсуса.`,
    },
    {
      id: 'mx',
      name: 'Мексика',
      flag: '🇲🇽',
      region: 'Americas',
      rationale:
        'Коллективистская, ориентированная на семью, высокая дистанция власти, выразительно-потворствующая',
      biases: [53, 48, 79, 37, 100, 7, 55, 75, 22, 84, 50, 41],
      confidence: 0.82,
      aliases: ['Мексиканец', 'Мексиканский', 'Mexican'],
      biasRationale: `Мексика имеет высокую дистанцию власти (81) при сильном коллективизме (IDV 30) и очень высоком допущении (97). Семейно-ориентированная культура формирует ингрупповой фаворитизм и авторитарное предубеждение, а экстремальное допущение создаёт гиперболическое дисконтирование и эффекты позитивности. Эмоционально выразительная культура усиливает настроенческо-конгруэнтную память и эффект угасания аффекта, а анекдотическое повествование и восприимчивость к эффекту Барнума отражают тёплую межличностную традицию.`,
    },
    {
      id: 'ma',
      name: 'Марокко',
      flag: '🇲🇦',
      region: 'Africa',
      rationale:
        'Высокая дистанция власти, коллективистская, высокое избегание неопределённости, сдержанная, ориентированная на традиции',
      biases: [48, 53, 93, 19, 90, 47, 70, 52, 88, 10, 30, 18],
      confidence: 0.67,
      aliases: ['Марокканец', 'Марокканский', 'Moroccan', 'Maghreb'],
      biasRationale: `Марокко имеет высокую дистанцию власти (70) при сильном коллективизме (IDV 25) и высоком избегании неопределённости (68). Ориентированная на традиции культура формирует консерватизм, авторитарное предубеждение и оправдание системы. Высокое избегание неопределённости порождает избегание неоднозначности, а коллективизм усиливает ингрупповой фаворитизм и аутгрупповую гомогенность. Базарная переговорная культура усиливает эффекты якорения, а сдержанность проявляется как эффекты бездействия и страуса.`,
    },
    {
      id: 'nl',
      name: 'Нидерланды',
      flag: '🇳🇱',
      region: 'Europe',
      rationale:
        'Высокий индивидуализм, эгалитарная, прямые коммуникаторы, низкая дистанция власти, потворствующая',
      biases: [77, 91, 44, 80, 79, 55, 94, 87, 71, 97, 74, 13],
      confidence: 0.87,
      aliases: ['Голландец', 'Голландский', 'Dutch', 'Holland'],
      biasRationale: `Нидерланды имеют очень высокий индивидуализм (80) при очень низкой дистанции власти (38) и высоком допущении (68). Прямая эгалитарная культура «полдермодели» формирует иллюзорное превосходство, реактивность и фундаментальную ошибку атрибуции. Высокое допущение порождает гиперболическое дисконтирование и эффекты позитивности, а аналитическая торговая традиция создаёт информационное предубеждение и вовлечённость через сложность обработки. Голландская прямота усиливает эффект третьего лица и склонность к Даннингу-Крюгеру.`,
    },
    {
      id: 'nz',
      name: 'Новая Зеландия',
      flag: '🇳🇿',
      region: 'Oceania',
      rationale:
        'Индивидуалистическая, эгалитарная, антипретенциозная, прагматичная, очень потворствующая',
      biases: [91, 44, 77, 13, 55, 80, 79, 70, 12, 97, 58, 74],
      confidence: 0.82,
      aliases: ['Новозеландец', 'Новозеландский', 'Kiwi', 'Aotearoa'],
      biasRationale: `Новая Зеландия имеет высокий индивидуализм (79) при низкой дистанции власти (22) и высоком допущении (75). Антипретенциозная культура «высокого мака» создаёт реактивность и социальную желательность, а эгалитаризм формирует фундаментальную ошибку атрибуции. Высокое допущение порождает гиперболическое дисконтирование и эффекты позитивности. Прагматичная культура киви ценит эффекты юмора и простоту по принципу «меньше — лучше», а нормальностное предубеждение отражает расслабленную ориентацию на образ жизни.`,
    },
    {
      id: 'ng',
      name: 'Нигерия',
      flag: '🇳🇬',
      region: 'Africa',
      rationale:
        'Коллективистская, высокая дистанция власти, предпринимательская, ориентированная на веру',
      biases: [48, 47, 31, 37, 40, 75, 69, 79, 78, 53, 41, 76],
      confidence: 0.73,
      aliases: ['Нигериец', 'Нигерийский', 'Nigerian', 'Naija'],
      biasRationale: `Нигерия имеет высокую дистанцию власти (80) при сильном коллективизме (IDV 30) и умеренном допущении (84). Ориентированная на веру культура усиливает ошибку справедливого мира и субъективное подтверждение, а предпринимательская культура «хастла» формирует сверхуверенность, компенсацию риска и иллюзию контроля. Высокое допущение создаёт гиперболическое дисконтирование, а устная традиция делает анекдотические свидетельства и эффекты Барнума крайне убедительными.`,
    },
    {
      id: 'no',
      name: 'Норвегия',
      flag: '🇳🇴',
      region: 'Europe',
      rationale:
        'Высокий индивидуализм, очень низкая дистанция власти, фемининная, потворствующая, эгалитарная',
      biases: [70, 58, 10, 97, 55, 80, 50, 93, 44, 13, 85],
      confidence: 0.84,
      aliases: ['Норвежец', 'Норвежский', 'Norwegian'],
      biasRationale: `Норвегия имеет высокий индивидуализм (69) при крайне низкой дистанции власти (31) и очень низкой маскулинности (8). Глубоко эгалитарная культура «Янтелаген» формирует социальную желательность и нормальностное предубеждение, подавляя самопрезентацию. Низкая маскулинность порождает консенсус через эффект подражания и предпочтения по принципу «меньше — лучше». Высокое допущение (55) создаёт эффекты позитивности и обращение к новизне, а структурированное общество порождает предубеждение к бездействию в принятии решений.`,
    },
    {
      id: 'pk',
      name: 'Пакистан',
      flag: '🇵🇰',
      region: 'Asia',
      rationale:
        'Очень высокая дистанция власти, коллективистская, сдержанная, ориентированная на традиции, маскулинная',
      biases: [48, 53, 47, 90, 50, 19, 52, 70, 30, 10, 88, 43],
      confidence: 0.72,
      aliases: ['Пакистанец', 'Пакистанский', 'Pakistani'],
      biasRationale: `Пакистан имеет очень высокую дистанцию власти (55) и коллективизм (IDV 14) при высокой маскулинности (50) и крайне низком допущении (0). Ориентированная на традиции культура с прочной авторитарной структурой формирует авторитарное предубеждение, оправдание системы и консерватизм. Экстремальная сдержанность порождает предубеждения к страусу и бездействию, а коллективизм создаёт ингрупповой фаворитизм, эффекты подражания и аутгрупповую гомогенность. Ошибка справедливого мира усиливается религиозными и социальными рамками.`,
    },
    {
      id: 'pe',
      name: 'Перу',
      flag: '🇵🇪',
      region: 'Americas',
      rationale:
        'Высокая дистанция власти, коллективистская, умеренное избегание неопределённости, сдержанная',
      biases: [48, 53, 50, 19, 90, 10, 30, 47, 79, 37, 88],
      confidence: 0.68,
      aliases: ['Перуанец', 'Перуанский', 'Peruvian'],
      biasRationale: `Перу имеет высокую дистанцию власти (64) при сильном коллективизме (IDV 16) и умеренном избегании неопределённости (87). Иерархическая культура формирует авторитарное предубеждение и оправдание системы, а коллективизм порождает ингрупповой фаворитизм и эффекты подражания. Высокое избегание неопределённости создаёт консерватизм, а сдержанность (IVR 46) проявляется как эффекты бездействия и страуса. Анекдотические традиции повествования остаются влиятельными в принятии решений.`,
    },
    {
      id: 'ph',
      name: 'Филиппины',
      flag: '🇵🇭',
      region: 'Asia',
      rationale:
        'Высокая дистанция власти, коллективистская, очень высокое допущение, ориентированная на семью',
      biases: [48, 53, 79, 55, 50, 13, 37, 75, 100, 47, 70, 41],
      confidence: 0.74,
      aliases: ['Филиппинец', 'Филиппинский', 'Filipino', 'Filipina', 'Pinoy'],
      biasRationale: `Филиппины имеют высокую дистанцию власти (94) при сильном коллективизме (IDV 32) и очень высоком допущении (42). Общинная культура «bayanihan» формирует ингрупповой фаворитизм и эффекты подражания, а уважение к авторитету порождает авторитарное предубеждение. Высокое допущение создаёт гиперболическое дисконтирование и эффекты позитивности. Тёплая, юмор-ориентированная культура усиливает эффекты юмора и восприимчивость к Барнуму, а эффект угасания аффекта отражает устойчивое отношение «bahala na».`,
    },
    {
      id: 'pl',
      name: 'Польша',
      flag: '🇵🇱',
      region: 'Europe',
      rationale:
        'Индивидуалистическая, высокое избегание неопределённости, маскулинная, сдержанная, прагматичная',
      biases: [93, 86, 19, 69, 44, 83, 81, 10, 30, 17, 25, 87],
      confidence: 0.8,
      aliases: ['Поляк', 'Польский', 'Polish', 'Pole'],
      biasRationale: `Польша имеет высокий индивидуализм (60) при очень высоком избегании неопределённости (93) и низком допущении (29). Сильное избегание неопределённости формирует предубеждения к неоднозначности и нулевому риску, а сдержанность порождает предубеждение к бездействию и эффекты страуса. Высокая маскулинность (64) создаёт сверхуверенность и фундаментальную ошибку атрибуции. Долгосрочная ориентация (38) в сочетании с исторической осторожностью порождает потерь-избегание, эскалацию обязательств и предубеждение к негативности.`,
    },
    {
      id: 'pt',
      name: 'Португалия',
      flag: '🇵🇹',
      region: 'Europe',
      rationale:
        'Склонная к коллективизму, очень высокое избегание неопределённости, фемининная, сдержанная',
      biases: [93, 86, 70, 10, 58, 50, 19, 83, 30, 100, 55, 85],
      confidence: 0.76,
      aliases: ['Португалец', 'Португальский', 'Portuguese'],
      biasRationale: `Португалия имеет самое высокое избегание неопределённости в Европе (99) при умеренном коллективизме (IDV 27) и низкой маскулинности (31). Экстремальное избегание неопределённости формирует предубеждения к неоднозначности и нулевому риску, а культурная меланхолия «saudade» создаёт эффект угасания аффекта и социальную желательность. Низкая маскулинность порождает нормальностное предубеждение и консенсусные эффекты подражания. Сдержанность (IVR 33) проявляется как предубеждения к бездействию и страусу, а потерь-избегание усиливается осторожной финансовой культурой.`,
    },
    {
      id: 'ro',
      name: 'Румыния',
      flag: '🇷🇴',
      region: 'Europe',
      rationale:
        'Высокая дистанция власти, склонная к коллективизму, высокое избегание неопределённости, сдержанная',
      biases: [48, 93, 90, 19, 10, 30, 83, 52, 53, 70, 17],
      confidence: 0.72,
      aliases: ['Румын', 'Румынский', 'Romanian'],
      biasRationale: `Румыния имеет высокую дистанцию власти (90) при высоком избегании неопределённости (90) и низком допущении (20). Сочетание сильной иерархии и избегания неопределённости формирует авторитарное предубеждение, оправдание системы и избегание неоднозначности. Экстремальная сдержанность порождает предубеждения к бездействию и страусу, а коллективистские тенденции создают ингрупповой фаворитизм и аутгрупповую гомогенность. Исторический скептицизм усиливает консерватизм, предубеждение к негативности и потерь-избегание.`,
    },
    {
      id: 'sa',
      name: 'Саудовская Аравия',
      flag: '🇸🇦',
      region: 'Middle East',
      rationale:
        'Высокая дистанция власти, коллективистская, сохраняющая традиции, сдержанная',
      biases: [48, 90, 19, 52, 43, 88, 47, 89, 53, 58, 70, 86],
      confidence: 0.82,
      aliases: ['Саудовец', 'Саудовский', 'Saudi', 'KSA'],
      biasRationale: `Саудовская Аравия имеет очень высокую дистанцию власти (95) при сильном коллективизме и высоком избегании неопределённости (80). Сохраняющая традиции культура формирует консерватизм, оправдание системы и авторитарное предубеждение. Коллективизм порождает ингрупповой фаворитизм, аутгрупповую гомогенность и групповые ошибки атрибуции. Сдержанная культура создаёт эффекты владения вокруг традиций и нормальностное предубеждение, а эффекты обратной отдачи отражают сопротивление нарративам быстрых культурных изменений.`,
    },
    {
      id: 'sg',
      name: 'Сингапур',
      flag: '🇸🇬',
      region: 'Asia',
      rationale:
        'Низкий индивидуализм, очень высокая дистанция власти, прагматичный, сдержанный, меритократический',
      biases: [48, 90, 49, 102, 85, 81, 83, 57, 86, 70, 50, 19, 93],
      confidence: 0.85,
      aliases: ['Сингапурец', 'Сингапурский', 'Singaporean'],
      biasRationale: `Сингапур имеет очень высокую дистанцию власти (74) при низком индивидуализме (20) и очень высокой долгосрочной ориентации (72). Прагматичная меритократическая культура формирует авторитарное предубеждение, оправдание системы и предубеждение к автоматизации от технологически развитого управления. Долгосрочная ориентация порождает эскалацию обязательств, потерь-избегание и ментальный учёт. Низкое допущение (46) создаёт предубеждение к нулевому риску и социальную желательность, а систематичное общество усиливает последовательное запоминание и единичное предубеждение.`,
    },
    {
      id: 'za',
      name: 'Южная Африка',
      flag: '🇿🇦',
      region: 'Africa',
      rationale:
        'Высокая дистанция власти, коллективистская, маскулинная, краткосрочно-ориентированная, сдержанная',
      biases: [48, 53, 52, 69, 44, 47, 79, 78, 37, 43, 91, 83],
      confidence: 0.74,
      aliases: ['Южноафриканец', 'Южноафриканский', 'Mzansi'],
      biasRationale: `Южная Африка имеет высокую дистанцию власти (49) при умеренном индивидуализме (65) и высокой маскулинности (63). Сложное мультикультурное общество порождает ингрупповой фаворитизм, аутгрупповую гомогенность и групповые ошибки атрибуции. Маскулинность формирует сверхуверенность и фундаментальную ошибку атрибуции, а краткосрочная ориентация (34) создаёт гиперболическое дисконтирование. Предпринимательская культура устойчивости усиливает компенсацию риска, а традиции анекдотического повествования остаются мощными. Реактивность отражает постколониальные паттерны сопротивления.`,
    },
    {
      id: 'kr',
      name: 'Южная Корея',
      flag: '🇰🇷',
      region: 'Asia',
      rationale:
        'Коллективистская, ориентированная на внешний вид, технологически развитая, конфуцианская иерархия',
      biases: [50, 54, 64, 80, 20, 70, 15, 77, 90, 84, 81, 83, 48],
      confidence: 0.88,
      aliases: ['Кореец', 'Южнокорейский', 'Корейский', 'Korean'],
      biasRationale: `Южная Корея имеет высокую долгосрочную ориентацию (100) и избегание неопределённости (85) при сильном коллективизме (IDV 18). Ориентированная на внешний вид культура «nunchi» усиливает эффект прожектора, эффект ореола и социальную желательность. Конфуцианская иерархия порождает авторитарное предубеждение и оправдание системы, а долгосрочная ориентация формирует эскалацию обязательств и потерь-избегание. Технологически развитая K-культура создаёт сильное обращение к новизне и эффекты IKEA от партиципативной фан-культуры.`,
    },
    {
      id: 'es',
      name: 'Испания',
      flag: '🇪🇸',
      region: 'Europe',
      rationale:
        'Склонная к коллективизму, очень высокое избегание неопределённости, склонная к фемининности, потворствующая',
      biases: [93, 86, 53, 55, 79, 50, 37, 22, 13, 100, 91, 20],
      confidence: 0.83,
      aliases: ['Испанец', 'Испанский', 'Spanish', 'Spaniard'],
      biasRationale: `Испания имеет очень высокое избегание неопределённости (86) при умеренном коллективизме (IDV 51) и высоком допущении (44). Избегание неопределённости формирует предубеждения к неоднозначности и нулевому риску, а допущение создаёт гиперболическое дисконтирование и эффекты позитивности. Социальная, ориентированная на семью культура порождает ингрупповой фаворитизм и эффекты подражания. Выразительный стиль общения усиливает эффекты обрамления и анекдотическую убедительность, а эффекты юмора и реактивность отражают страстный средиземноморский темперамент.`,
    },
    {
      id: 'se',
      name: 'Швеция',
      flag: '🇸🇪',
      region: 'Europe',
      rationale:
        'Эгалитарная, ищущая консенсуса, низкое допущение, культура умеренности «Lagom»',
      biases: [93, 70, 10, 58, 76, 97, 30, 85, 50, 17, 44, 80],
      confidence: 0.88,
      aliases: ['Швед', 'Шведский', 'Swedish', 'Swede'],
      biasRationale: `Швеция имеет очень высокий индивидуализм (71) при крайне низкой дистанции власти (31) и очень низкой маскулинности (5). Культура умеренности «Lagom» формирует социальную желательность, нормальностное предубеждение и предубеждение к бездействию через стремление к консенсусу. Низкая маскулинность создаёт предпочтения по принципу «меньше — лучше» и подражательное соответствие групповым нормам. Прогрессивная культура порождает обращение к новизне, сохраняя избегание неоднозначности, а фундаментальная ошибка атрибуции отражает индивидуалистическую меритократическую систему убеждений.`,
    },
    {
      id: 'ch',
      name: 'Швейцария',
      flag: '🇨🇭',
      region: 'Europe',
      rationale:
        'Индивидуалистическая, высокое избегание неопределённости, умеренная дистанция власти, сдержанная, движимая точностью',
      biases: [86, 93, 94, 87, 102, 19, 81, 83, 85, 97, 10, 49],
      confidence: 0.84,
      aliases: ['Швейцарец', 'Швейцарский', 'Swiss'],
      biasRationale: `Швейцария имеет высокий индивидуализм (68) при заметном избегании неопределённости (58) и умеренной сдержанности (IVR 66). Движимая точностью культура усиливает предубеждение к нулевому риску, избегание неоднозначности и информационное предубеждение. Банковские и часовые традиции усиливают вовлечённость через сложность обработки и последовательное запоминание. Долгосрочная ориентация (74) формирует эскалацию обязательств и потерь-избегание, а консенсусная прямая демократия создаёт предубеждение к бездействию и предпочтения по принципу «меньше — лучше».`,
    },
    {
      id: 'th',
      name: 'Таиланд',
      flag: '🇹🇭',
      region: 'Asia',
      rationale:
        'Высокая дистанция власти, коллективистская, низкое избегание неопределённости, сдержанная, ищущая гармонии',
      biases: [48, 50, 53, 70, 55, 58, 10, 22, 90, 47, 100, 13],
      confidence: 0.75,
      aliases: ['Таец', 'Тайский', 'Thai', 'Siam'],
      biasRationale: `Таиланд имеет высокую дистанцию власти (64) при сильном коллективизме (IDV 20) и низком избегании неопределённости (64). Ищущая гармонии культура «kreng jai» формирует социальную желательность, предубеждение к бездействию и нормальностное предубеждение через избегание конфликтов. Высокая дистанция власти порождает авторитарное предубеждение и оправдание системы, а коллективизм создаёт эффекты подражания и ингрупповой фаворитизм. Буддистски-влиянное отношение «mai pen rai» порождает эффект угасания аффекта и эффекты позитивности.`,
    },
    {
      id: 'tr',
      name: 'Турция',
      flag: '🇹🇷',
      region: 'Middle East',
      rationale:
        'Коллективистская, высокая дистанция власти, культура переговоров, основанная на чести',
      biases: [48, 18, 53, 81, 22, 43, 52, 88, 47, 25, 93, 90],
      confidence: 0.82,
      aliases: ['Турок', 'Турецкий', 'Turkish', 'Türkiye'],
      biasRationale: `Турция имеет высокую дистанцию власти (66) при сильном коллективизме (IDV 37) и высоком избегании неопределённости (85). Богатая переговорами культура усиливает эффекты якорения и обрамления, а основанные на чести социальные кодексы формируют ингрупповой фаворитизм и групповые ошибки атрибуции. Высокое избегание неопределённости порождает избегание неоднозначности и оправдание системы. Эскалация обязательств отражает культурный акцент на настойчивости и выполнении социальных обязательств.`,
    },
    {
      id: 'ae',
      name: 'ОАЭ',
      flag: '🇦🇪',
      region: 'Middle East',
      rationale:
        'Очень высокая дистанция власти, коллективистская, ориентированная на будущее, статусно-сознательная, космополитичная',
      biases: [48, 54, 80, 90, 53, 88, 20, 57, 79, 15, 86, 50],
      confidence: 0.74,
      aliases: ['Эмиратец', 'Эмиратский', 'UAE', 'Emirati', 'Dubai'],
      biasRationale: `ОАЭ имеют очень высокую дистанцию власти (90) при сильном коллективизме (IDV 25) и заметной сдержанности. Статусно-сознательная космополитичная культура усиливает эффекты ореола, отличительности фон Ресторфф и контраста. Высокая дистанция власти формирует авторитарное предубеждение и оправдание системы, а ориентированный на будущее менталитет развития создаёт обращение к новизне. Ментальный учёт выражен в люкс-коммерческой культуре, а предубеждение к нулевому риску отражает акцент на премиум-качестве и безопасности.`,
    },
    {
      id: 'ua',
      name: 'Украина',
      flag: '🇺🇦',
      region: 'Europe',
      rationale:
        'Умеренный коллективизм, высокое избегание неопределённости, сдержанная, устойчивая, низкая дистанция власти',
      biases: [1, 83, 91, 19, 93, 17, 81, 84, 78, 10, 53],
      confidence: 0.68,
      aliases: ['Украинец', 'Украинский', 'Ukrainian'],
      biasRationale: `Украина имеет умеренный индивидуализм (25) при высоком избегании неопределённости (95) и очень низком допущении (18). Устойчивая культура, сформированная историческими потрясениями, усиливает эвристику доступности и предубеждение к негативности. Высокое избегание неопределённости создаёт избегание неоднозначности и консерватизм, а экстремальная сдержанность порождает предубеждение к бездействию. Сильные общинные связи формируют ингрупповой фаворитизм, а изобретательная DIY-культура создаёт эффекты IKEA. Реактивность и компенсация риска отражают адаптивные ответы на невзгоды.`,
    },
    {
      id: 'gb',
      name: 'Великобритания',
      flag: '🇬🇧',
      region: 'Europe',
      rationale:
        'Индивидуалистическая, сдержанная, уважающая традиции, культура сухого юмора',
      biases: [20, 97, 13, 30, 71, 19, 88, 105, 12, 17, 91, 83],
      confidence: 0.89,
      aliases: ['Британец', 'Британский', 'Англичанин', 'British', 'English'],
      biasRationale: `Великобритания имеет очень высокий индивидуализм (89) при низкой дистанции власти (35) и умеренном допущении (69). Сдержанная культура формирует эффекты «меньше — лучше» и контраста через тонкую коммуникацию. Сухой юмор усиливает эффекты юмора и странности, а уважающий традиции консерватизм создаёт эффекты владения и страуса. Высокий индивидуализм порождает эффект третьего лица и реактивность, а предубеждение к негативности отражает культурно укоренённый скептицизм и сдержанность.`,
    },
    {
      id: 'us',
      name: 'США',
      flag: '🇺🇸',
      region: 'Americas',
      rationale:
        'Индивидуалистическая, низкое избегание неопределённости, насыщенная маркетингом, культура мгновенного вознаграждения',
      biases: [77, 79, 69, 50, 80, 22, 83, 37, 71, 91, 44, 74, 78],
      confidence: 0.9,
      aliases: ['Американец', 'Американский', 'American', 'USA'],
      biasRationale: `США имеют исключительно высокий индивидуализм (91) и низкое избегание неопределённости (46), создавая культуру, которая вознаграждает самопрезентацию и принятие риска. В сочетании с высоким допущением (68) американцы особенно восприимчивы к предубеждениям мгновенного вознаграждения и сверхуверенности в собственных суждениях. Насыщенная маркетингом среда усиливает эффекты обрамления, давление подражания и обращение к новизне.`,
    },
    {
      id: 'vn',
      name: 'Вьетнам',
      flag: '🇻🇳',
      region: 'Asia',
      rationale:
        'Коллективистская, высокая дистанция власти, долгосрочно-ориентированная, сдержанная, ищущая гармонии',
      biases: [48, 50, 53, 81, 83, 70, 90, 10, 57, 19, 58, 42],
      confidence: 0.73,
      aliases: ['Вьетнамец', 'Вьетнамский', 'Vietnamese'],
      biasRationale: `Вьетнам имеет высокую дистанцию власти (70) при сильном коллективизме (IDV 20) и очень высокой долгосрочной ориентации (57). Конфуциански-влиянная культура формирует авторитарное предубеждение, оправдание системы и социальную желательность через стремление к гармонии. Долгосрочная ориентация порождает эскалацию обязательств, потерь-избегание и ментальный учёт. Коллективизм создаёт эффекты подражания и ингрупповой фаворитизм, а сдержанность (IVR 35) проявляется как предубеждение к бездействию и нормальностное предубеждение.`,
    },
  ],

  regions: {
    All: 'Все',
    Americas: 'Америка',
    Europe: 'Европа',
    Asia: 'Азия',
    'Middle East': 'Ближний Восток',
    Africa: 'Африка',
    Oceania: 'Океания',
  },

  ui: {
    chooseYour: 'Выбери свою',
    cyclingWords: ['Персону', 'Оппонента', 'Целевую аудиторию', 'Соперника'],
    cyclingBoldWord: 'Персону',
    subTaglineLead: 'Вы попросили — мы сделали. ',
    subTagline:
      'Выбери страну, чтобы автоматически заполнить профиль когнитивных искажений. Каждый шаблон выделяет 10–15 искажений с повышенной культурной распространённостью — готов к использованию в конструкторе персон.',
    statTemplates: 'Шаблонов национальностей',
    statReady: 'Готово, когда ты готов',
    loadingMap: 'Загрузка карты…',
    tooltipBiases: 'искажений',
    tooltipHint: 'Нажми, чтобы увидеть профиль искажений',
    searchPlaceholder: 'Поиск страны или национальности...',
    moreCountries: (n: number) => `+${n} ещё стран`,
    showLess: 'Показать меньше',
    matchSuffix: '% совпадение',
    whyTheseBiases: 'Почему эти искажения?',
    whyApproxNote:
      'Это приблизительная оценка, отражающая, насколько шаблон искажений соответствует задокументированным поведенческим паттернам этой страны.',
    hofstedeNote:
      'На основе культурных измерений Хофстеде и охвата поведенческих исследований.',
    useInPersonaBuilder: 'Заполнить персону {country}',
    emptyStateLead: 'Выбери страну и ',
    emptyStateLink: 'увидь будущее своего бизнеса',
    emptyStateHint: 'Нажми, чтобы загрузить шаблон искажений',
    footerBiases: 'искажений',
    footerConfidence: 'уверенности',
  },
};
